class StickyHeader extends HTMLElement {
  constructor() {
    super();

    this.targets = document.querySelectorAll("[data-header-target]");
    this.sticking = false;
    this.hiding = false;

    const setHeightVariable = () =>
      document.documentElement.style.setProperty(
        "--header-height",
        `${this.getBoundingClientRect().height}px`
      );
    window.requestAnimationFrame(setHeightVariable);
    window.addEventListener("resize", setHeightVariable);

    this.highlighters = new Set();

    this.highlight = (highlighter) => {
      this.highlighters.add(highlighter);
      this.classList.add("highlight");
      document.body.classList.add("header-menu-open");
    };

    this.removeHighlight = (highlighter) => {
      this.highlighters.delete(highlighter);

      if (!this.highlighters.size) {
        this.classList.remove("highlight");
        document.body.classList.remove("header-menu-open");
      }
    };

    this._moveStickTarget();
    this._initObserver();
    this._initScrollToggle();

    this.addEventListener("menu:open", (e) => {
      this.highlight(e.target);
    });

    this.addEventListener("menu:close", (e) => {
      this.removeHighlight(e.target);
    });

    this.querySelectorAll(".header__main-nav-link").forEach((link) => {
      link.addEventListener("mouseover", () => this.highlight(link));
      link.addEventListener("mouseleave", () => this.removeHighlight(link));
    });
  }

  _initObserver() {
    const cb = (entries) => {
      entries.forEach((entry) => {
        switch (entry.target.dataset.headerTarget) {
          case "stick":
            this.sticking = !entry.isIntersecting;
            this.classList.toggle("sticking", this.sticking);
            document.body.classList.toggle("header--sticking", this.sticking);
            break;
          case "hide":
            this.hiding = !entry.isIntersecting;
            break;
        }
      });
    };

    const observer = new IntersectionObserver(cb, {});
    this.targets.forEach((target) => observer.observe(target));
  }

  _initScrollToggle() {
    let lastScroll = window.pageYOffset;
    window.addEventListener("scroll", () => {
      const scrollDelta = window.pageYOffset - lastScroll;
      const hide = this.hiding && scrollDelta > 0;
      this.classList.toggle("hide", hide);
      document.body.classList.toggle("header--hide", hide);

      lastScroll = window.pageYOffset;
    });
  }

  _moveStickTarget() {
    // Moving this element in editor messes things up (sections disappear when you change things)
    // so just skip.
    if (Shopify?.designMode) return;

    // Move stick target before header (but after promo bar, if present)
    // We can't directly place the target there because these are both
    // sections in a section group.
    const target = document.querySelector('[data-header-target="stick"]');
    const header = this.closest(".shopify-section--header");
    header.parentNode.insertBefore(target, header);
  }
}

if (!customElements.get("sticky-header")) {
  customElements.define("sticky-header", StickyHeader);
}
